const getScaleAndImgSize = async (file: File, maxWidth: number, maxHeight: number = maxWidth) => {
  const reader = new FileReader();
  const result = await new Promise<string>((resolve, reject) => {
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });

  const img = new Image();
  img.src = result;

  await new Promise<void>(resolve => {
    img.onload = () => resolve();
    img.onerror = event => console.log(event);
  });

  const scale = Math.min(maxWidth / img.width, maxHeight / img.height);

  return { scale, imgW: img.width, imgH: img.height };
};

export { getScaleAndImgSize };
